export var UserActions;
(function (UserActions) {
    UserActions["STATE_RESET"] = "USER/STATE_RESET";
    UserActions["STATE_UPDATE"] = "USER/STATE_UPDATE";
})(UserActions || (UserActions = {}));
